export const actions = {
  SET_TRACKS_DATA: "SET_TRACKS_DATA",
  TOGGLE_PLAY: "TOGGLE_PLAY",
  NEXT_SONG: "NEXT_SONG",
  PREV_SONG: "PREV_SONG",
  TOGGLE_SAVE_TRACK: "TOGGLE_SAVE_TRACK",
};
